import { render, staticRenderFns } from "./DashboardDataTable.vue?vue&type=template&id=4b98c598&"
import script from "./DashboardDataTable.vue?vue&type=script&lang=ts&"
export * from "./DashboardDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports